import Page from "../Components/Page";

function StartPage() {
    const endpoint = '/pages/start';

    return <Page endpoint={endpoint} />
}

export default StartPage;